import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { DataItem, connect } from 'scrivito'

import { DocumentFolderBox } from './DocumentFolderBox'
import { buildFolderMenuItems } from './menuItems'
import { UnlinkFolderModal } from '../Modal/UnlinkFolderModal'
import { RenameFolderModal } from '@/Components/Document/Modal/RenameFolderModal'
import { useDocumentContext } from '@/hooks/documents/useDocumentHandler'

interface DocumentFolderItemProps {
  document: DataItem
  schema: DataItem
}

export const DocumentFolderItem: React.FC<DocumentFolderItemProps> = connect(
  ({ document }) => {
    const { t } = useTranslation()
    const displayTitle = document.get('displayTitle') as string
    const isFolder = document.get('folder') as boolean

    const { openFolder } = useDocumentContext()
    const id = document.id()

    const onOpenFolder = (e: React.MouseEvent) => {
      e.stopPropagation()
      openFolder(id)
    }

    if (!isFolder) return

    const [isRenameOpen, setIsRenameOpen] = useState(false)
    const [isUnlinkOpen, setIsUnlinkOpen] = useState(false)

    const menuItems = buildFolderMenuItems(t, {
      onRename: () => setIsRenameOpen(true),
      onUnlink: () => setIsUnlinkOpen(true),
    })

    return (
      <li>
        <DocumentFolderBox
          key={document.id()}
          document={document}
          onClick={onOpenFolder}
          title={displayTitle}
          menuItems={menuItems}
        />
        <RenameFolderModal
          isOpen={isRenameOpen}
          close={() => setIsRenameOpen(false)}
          document={document}
        />
        <UnlinkFolderModal
          isOpen={isUnlinkOpen}
          close={() => setIsUnlinkOpen(false)}
          document={document}
        />
      </li>
    )
  },
)
